<template>
    <div>
        <div class="inputflex">
            <div v-if="flag">{{ value }}</div>
            <div v-else>
                <input type="text" ref="inputs" :value="value" @input="updateValue($event)">
            </div>
            <div class="btn" v-if="flag" @click="chang">修改</div>
            <div class="btn" v-else @click="confirm">确定</div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['value'],
    name: '',
    data() {
        return {
            flag: true,
        }
    },
    mounted() {

    },
    methods: {
        chang() {
            this.flag = false
            this.$nextTick(() => {
                this.$refs.inputs.focus()
            })
        },
        confirm(){
            if(this.value == ''){
                this.$modal.msgError(`金额不能为空`);
                return
            }
            if(!this.isNumeric(this.value)){
                this.$modal.msgError(`金额不正确`);
                return
            }
            this.flag = true
        },
        updateValue(event) {
            this.$emit('input', event.target.value);
        },
        isNumeric(str) {
            return !isNaN(str) && !isNaN(parseFloat(str));
        }
    },
}
</script>
<style lang='scss' scoped>
.inputflex {
    font-size: 16px;
    display: flex;
    align-items: center;
    height: 24px;
    input {
        max-width: 100px;
        border: none;
        outline: none;
        font-size: 16px;
    }
    .btn {
        margin-left: 30px;
        flex: 1;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #FF9500;
        cursor: pointer;
    }
}
</style>